const MetaData = (props) => {
  return <title>{props.title}</title>;
};

export default MetaData;
